import { render, staticRenderFns } from "./wordCla.vue?vue&type=template&id=9932581c&"
import script from "./wordCla.vue?vue&type=script&lang=js&"
export * from "./wordCla.vue?vue&type=script&lang=js&"
import style0 from "./wordCla.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports